import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular,
	},
}));

export default function SimpleAccordion() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header">
					<Typography className={classes.heading}>
						What is iExchange?
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography className="faq__answers">
						iexchnage is a peer-to-peer and Bureau D’change powered currency
						exchange platform. We are the solution to your currency exchange
						needs by connecting people with similar needs to each other
					</Typography>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header">
					<Typography className={classes.heading}>How does it work?</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography className="faq__answers">
						Once you create a profile with us in minutes, you have access to
						people with similar needs that you can find in our currency market
						place. Simply look for people in need of your currency and negotiate
						your rate or open a bidding round for your specific need.
					</Typography>
				</AccordionDetails>
			</Accordion>

      <Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header">
					<Typography className={classes.heading}>What is a bidding round?</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography className="faq__answers">
						It is a post telling people on the platform about your currency needs- the currency you need, how much you need, rate you are willing to pay and currency you have to trade.
					</Typography>
				</AccordionDetails>
			</Accordion>

      <Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header">
					<Typography className={classes.heading}>How do I trust people?</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography className="faq__answers">
						The platform has embedded a digital escrow system to ensure both the buyer and seller can transact with a measure of trust by introducing a middle man that makes sure services are delivered according to agreed terms and condition.
					</Typography>
				</AccordionDetails>
			</Accordion>

      <Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header">
					<Typography className={classes.heading}>Will I get a Dollar Card if needed?</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography className="faq__answers">
						Yes, a virtual dollar card is available on the platform. However you have the option to activate or not to.
					</Typography>
				</AccordionDetails>
			</Accordion>

      <Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header">
					<Typography className={classes.heading}>Is the platform free to use?</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography className="faq__answers">
						Charges may apply depending on the transaction been carried out but we will be transparent and inform you about them.
					</Typography>
				</AccordionDetails>
			</Accordion>
		</div>
	);
}
